module.exports = __webpack_public_path__ + "img/p_share.c6a9687e.png";